import _toConsumableArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _createForOfIteratorHelper from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import { DTPWeb, LPA_JobNames, LPA_PrintActions } from 'dtpweb';
export default {
  name: 'print-code',
  props: {
    codes: {
      type: Array,
      required: true
    },
    expressNum: {
      type: String
    },
    expressName: {
      type: String
    }
  },
  computed: {
    isHX: function isHX() {
      return this.$store.state.cpscc.isHX;
    }
  },
  data: function data() {
    return {
      printers: [],
      api: undefined,
      currPrinter: undefined,
      model: {
        currPrinter: undefined
      }
    };
  },
  methods: {
    checkPrintState: function checkPrintState() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$_this$$awaitTo, _yield$_this$$awaitTo2, err, api;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              // 有没有装驱动 https://detonger.com/software-driver-download.html
              DTPWeb.getInstance();
              _context.n = 1;
              return _this.$awaitTo(new Promise(function (resolve, reject) {
                DTPWeb.checkServer(function (value) {
                  if (!value) {
                    return reject(new Error('打印服务不可用, 请检查是否已安装相关打印机驱动(https://detonger.com/software-driver-download.html)'));
                  }
                  return resolve(value);
                });
              }));
            case 1:
              _yield$_this$$awaitTo = _context.v;
              _yield$_this$$awaitTo2 = _slicedToArray(_yield$_this$$awaitTo, 2);
              err = _yield$_this$$awaitTo2[0];
              api = _yield$_this$$awaitTo2[1];
              if (!err) {
                _context.n = 2;
                break;
              }
              _this.$message.error(err.message);
              return _context.a(2);
            case 2:
              _this.api = api;
              _this.getPrinters();
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    getPrinters: function getPrinters() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var values, printers, _iterator, _step, item, title;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              // 获取所有德佟的P1打印机
              values = _this2.api.getPrinters();
              printers = [];
              _iterator = _createForOfIteratorHelper(values);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  item = _step.value;
                  title = _this2.api.isLocalPrinter(item) ? item.name : "".concat(item.name, "@").concat(item.ip);
                  printers.push({
                    name: title,
                    value: item
                  });
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              _this2.printers = printers.map(function (item, index) {
                return _objectSpread(_objectSpread({}, item), {}, {
                  _id: index
                });
              });
              if (values.length) {
                _this2.model.currPrinter = values[0];
              } else {
                _this2.$message.error('未能搜索到德佟P1打印机, 请检查是否已链接电脑');
              }
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    addPreview: function addPreview(data) {
      if (!data) return;
      var previewGroup = this.$refs['preview-list'];
      var img = document.createElement('img');
      img.src = data;
      previewGroup.appendChild(img);
      // 换行
      previewGroup.appendChild(document.createElement('br'));
    },
    toPrint: function toPrint() {
      var _arguments = arguments,
        _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var type, _yield$_this3$$awaitT, _yield$_this3$$awaitT2, err, printerName, printAction, width, height, margin, orientation, jobName, text;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              type = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : 1;
              _context3.n = 1;
              return _this3.$awaitTo(new Promise(function (resolve, reject) {
                _this3.api.openPrinter(_this3.model.currPrinter, function (success) {
                  if (success) {
                    resolve();
                  } else {
                    reject('未能打开打印机, 请尝试点击打开打印机按钮并再次点击打印按钮');
                  }
                });
              }));
            case 1:
              _yield$_this3$$awaitT = _context3.v;
              _yield$_this3$$awaitT2 = _slicedToArray(_yield$_this3$$awaitT, 1);
              err = _yield$_this3$$awaitT2[0];
              if (!err) {
                _context3.n = 2;
                break;
              }
              _this3.$message.error(err);
              return _context3.a(2);
            case 2:
              printerName = _this3.model.currPrinter ? _this3.model.currPrinter.name : undefined;
              if (printerName) {
                _context3.n = 3;
                break;
              }
              return _context3.a(2);
            case 3:
              printAction = LPA_PrintActions.Print;
              width = 45;
              height = 30;
              margin = 1;
              if (type === 1) {
                _this3.api.print({
                  action: printAction,
                  printerInfo: {
                    printerName: _this3.model.currPrinter.name
                  },
                  jobInfo: {
                    jobWidth: width,
                    jobHeight: height,
                    orientation: 0
                  },
                  jobPages: _toConsumableArray(_this3.codes.map(function (code) {
                    return [{
                      type: 'barcode',
                      text: code,
                      x: 5,
                      y: 5,
                      width: width - 5 * 2,
                      height: height - 5 * 2,
                      textHeight: 5,
                      horizontalAlignment: 1
                      // textAlignment: 3
                    }];
                  })),
                  callback: function callback(results) {
                    _this3.api.closePrinter();
                  }
                });
              } else {
                orientation = _this3.currOrientation;
                jobName = _this3.currJobName;
                text = "\u51FD\u8BC1\u7F16\u7801\n".concat(_this3.codes[0], "\n\n").concat(_this3.expressName, "\n").concat(_this3.expressNum); //
                _this3.api.startJob({
                  width: width,
                  height: height,
                  orientation: orientation,
                  jobName: jobName
                });
                // this.api.drawRectangle({ width, height, lineWidth: 0.35 })
                _this3.api.drawText({
                  text: text,
                  width: width,
                  height: height,
                  fontHeight: 4,
                  lineSpace: 5,
                  verticalAlignment: 1,
                  horizontalAlignment: 1,
                  textAlignment: 1
                });
                _this3.api.commitJob(function (success) {
                  if (success) {
                    // 如果当前任务类型为预览类型，则显示预览效果
                  }
                });
              }
            case 4:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    previewJobs: function previewJobs() {
      // 先清空预览区域；
      this.$refs['preview-list'].innerHTML = '';

      // 现获取当前打印任务的页数，然后遍历页面图片；
      var info = this.api.getPageInfo();
      // 遍历所有页面数据，然后添加到预览区域
      if (info) {
        var pages = [];
        for (var i = 0; i < info.pages; i++) {
          var page = this.api.getPageImage({
            page: i
          });
          pages.push(page.data);
        }
        this.previewPages(pages);
      }
    },
    previewPages: function previewPages(pages) {
      if (pages && pages.length > 0) {
        var _iterator2 = _createForOfIteratorHelper(pages),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var page = _step2.value;
            this.addPreview(page);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }
  },
  mounted: function mounted() {
    this.checkPrintState();
  }
};